import {errorToNotifObj, getLSLang} from "../helpers";

import {getIdToken} from './auth'; //isLoggedIn
import axios from "axios";
import history from "../helpers/history";
import notify from "../helpers/toast";
import {logoutHandler} from "../helpers/logoutHandler";

let node_api_url = "https://wbot.prestamistapp.net/api"
// let node_api_url =  "http://localhost:8080/api";


export {node_api_url};
export const NODE_API = axios.create({
    baseURL: node_api_url,
    // timeout: 1000,
    headers: { 'contentType': 'application/json; charset=utf-8', "accept-language": "es-US" }
})
NODE_API.interceptors.request.use(function (request) {
    const tokenId = getIdToken();
    request.headers["accept-language"] = getLSLang("l") === "en" ? "en-US" : "es-ES";
    request.headers["x-lang"] = getLSLang("l")
    // const decoded = jwt_decode(localStorage._token);
    //
    // const currentTime = Date.now() / 1000;
    // if(decoded.exp < currentTime) {
    //     store.dispatch(logoutUser());
    //     window.location.href = '/login'
    // }
    //
    if (tokenId) request.headers.Authorization = `Bearer ${tokenId}`;

   // if (!window.navigator.onLine) alert("no estas conectado a internet");
    return request;
})
NODE_API.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response) {
        if (error.response.status === 401) {
            // localStorage.removeItem('_token');
            if (history.location.pathname.indexOf("/report") !== -1) {
                window.close();
            }
            //  history.replace("/login", { backurl: history.location.pathname })
            logoutHandler()
        } else if (error.response.status === 403) {
            notify.warning({ title: 'Acceso denegado', message: 'Necesita permisos para realizar esta acción.' });
        } else {
            notify.error(errorToNotifObj(error?.response?.data));
        }
    }
    return Promise.reject(error);
});


export interface IEmployeeLocation {
    latitude: number;
    longitude: number;
    timestamp?: Date; // opcional, si quieres permitir que venga
}


export function getNodeUsers() {
    return NODE_API.get('allUsers');
}
export function checkWhatsappNumber(number:string) {
    return NODE_API.get('web/check-number?number=' + number);
}
export function getNodeAgentTracking(userId: number) {
    return NODE_API.get('user/locations', { params:{userId} });
}
export function postNodeAgentTracking(locations: IEmployeeLocation[]) {
    return NODE_API.post('user/locations', {locations});
}

// ===============================
// 🚀 Servicios
// ===============================

// 🔹 Obtener todas las respuestas automáticas
export const getAutoResponses = async (): Promise<ApiResponse<AutoResponse[]>> => {
    const { data } = await NODE_API.get<ApiResponse<AutoResponse[]>>("/autoResponse");
    return data;
};

// 🔹 Crear una nueva respuesta automática
export const createAutoResponse = async (
    autoResponse: Omit<AutoResponse, "_id" | "companyId">
): Promise<ApiResponse<AutoResponse>> => {
    const { data } = await NODE_API.post<ApiResponse<AutoResponse>>("/autoResponse", autoResponse);
    return data;
};

// 🔹 Actualizar una respuesta automática
export const updateAutoResponse = async (
    autoResponse: Partial<AutoResponse>
): Promise<ApiResponse<AutoResponse>> => {
    const { data } = await NODE_API.put<ApiResponse<AutoResponse>>(`/autoResponse/${autoResponse._id}`, autoResponse);
    return data;
};

// 🔹 Eliminar una respuesta automática
export const deleteAutoResponse = async (id: string): Promise<ApiResponse<null>> => {
    const { data } = await NODE_API.delete<ApiResponse<null>>(`/autoResponse/${id}`);
    return data;
};
//Users
export const getNodeCurrentUser = async (): Promise<ApiResponse<INodeUser>> => {
    const { data } = await NODE_API.get<ApiResponse<INodeUser>>("/user/me");
    return data;
};


export const updateUser = async (
    setting: Partial<INodeUser>
): Promise<ApiResponse<INodeUser>> => {
    const { data } = await NODE_API.put<ApiResponse<INodeUser>>(`/user`, setting);
    return data;
};


export interface AutoResponse {
    _id?: string;
    companyId?: number;
    keywords: string;
    response: string;
    createdAt?: string;
    updatedAt?: string;
}
export interface INodeUser {
    _id?: string;
    companyId?: number;
    shareSession?:boolean,
    autoResponseEnabled?:boolean
    createdAt?: string;
    updatedAt?: string;
}
export interface ApiResponse<T = any> {
    success: boolean;
    message?: string;
    data?: T;
    // [key: string]: any; // permite cualquier otra propiedad adicional
}
